export default __webpack_public_path__ + "static/media/logo-dark.59996f53.svg";